<template>
  <div class="setup-content basic-info" id="step-1">
    <div class="form-row justify-content-between">
      <div>
        <h3 class="color-darkblue">Claim Header</h3>
      </div>
      <div v-if="viewAllfields" class="verified-checkbox mr-4">
        <div class="form-group row claim-verified-checkbox pt-7">
          <label for="claim_section_verified" class="control-label claim-mr-2">Verified:</label>
          <input type="checkbox" v-model="section_verified" :disabled="disableAllFields" name="claim_section_verified" id="claim_section_verified" />
        </div>
      </div>
    </div>

    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <label class="control-label require">Dealer Location:</label>

        <v-select v-if="loadAllDealers" v-model="dealer_id" name="dealer_id" label="text" :filterable="false"
          :options="modifiedDealerArr" @search="onSearchDealer" readonly placeholder="Select Dealer"
          :disabled="disableClaimHeader || dealerFieldsDisabled || disableAllFields" class='custom-ci-auto-search close-remove'>
          <template slot="no-options">
            Search Dealer...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <v-select v-else v-model="dealer_id" name="dealer_id" label="text" :filterable="false"
          :options="modifiedDealerArr" readonly
          :disabled="disableClaimHeader || dealerFieldsDisabled || disableAllFields"
          placeholder="Select Dealer" class='custom-ci-auto-search close-remove'>
          <template slot="no-options">
            Select Dealer...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <div class="field-error">{{ dealer_location_err_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Dealer Group:</label>
        <input disabled type="text" v-model="dealer_group" class="form-control" placeholder="Enter Dealer Group"
          name="dealer_group" id="dealer_group" />
        <div class="field-error">{{ dealer_group_err_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Dealer Code:</label>
        <input disabled type="text" v-model="dealer_code" class="form-control" placeholder="Enter Dealer Group"
          name="dealer_code" id="dealer_code" />
        <div class="field-error">{{ dealer_code_err_msg }}</div>
      </div>

      <div class="col form-group">
        <label :class="isEdit ? 'require control-label' : 'control-label'" for="code">Claim #:</label>
        <input type="text" class="form-control" :disabled="true" v-model="claim_number" id="code"
          placeholder="Enter Claim Number" name="claim_number">
        <div class="field-error">{{ claim_number_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Claim Type:</label>
        <v-select class="close-remove" v-model="claim_type" :disabled="disableClaimHeader || disableAll || disableAllFields" id="claim_type" name="claim_type"
          placeholder="Select Claim Type" @change="claimTypeChanged($event)" label="text" :options="claimTypeArr">
        </v-select>
        <div class="field-error">{{ claim_type_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Claim Status:</label>
        <v-select class="close-remove" v-model="claim_status" :disabled="disableClaimHeader || !viewAllfields || disableAllFields" id="claim_status"
          name="claim_status" placeholder="Select Claim Status" @change="claimStatusChanged($event)" label="text"
          :options="claimStatusArr">
        </v-select>
        <div class="field-error">{{ claim_status_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label">Last Modification:</label>
        <div class="input-group">
          <date-picker placeholder="MM/DD/YYYY" id="last_modification_date" name="last_modification_date"
            v-model="last_modification_date" :config="optionsDate" disabled></date-picker>
          <label for="last_modification_date" class="fp-calendar input-calender-icon"></label>
        </div>
        <div class="field-error">{{ last_modification_date_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label">Claim Date:</label>
        <div class="input-group">
          <date-picker placeholder="MM/DD/YYYY" id="claim_date" name="claim_date" v-model="claim_date"
            :config="optionsDate" disabled></date-picker>
          <label for="claim_date" class="fp-calendar input-calender-icon"></label>
        </div>
        <div class="field-error">{{ claim_date_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Repair Start Date:</label>
        <div class="input-group">
          <date-picker placeholder="MM/DD/YYYY" id="repair_start_date" name="repair_start_date"
            v-model="repair_start_date" :config="repairOptionsDate" :disabled="disableClaimHeader || dealerFieldsDisabled || disableAllFields"></date-picker>
          <label for="repair_start_date" class="fp-calendar input-calender-icon"></label>
        </div>
        <div class="field-error">{{ repair_start_date_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Repair Completion Date:</label>
        <div class="input-group">
          <date-picker placeholder="MM/DD/YYYY" id="repair_completion_date" name="repair_completion_date"
            v-model="repair_completion_date" :config="repairCompletionOptionsDate"
            :disabled="disableClaimHeader || disableCompletionDate || dealerFieldsDisabled || disableAllFields"></date-picker>
          <label for="repair_completion_date" class="fp-calendar input-calender-icon"></label>
        </div>
        <div class="field-error">{{ repair_completion_date_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Dealer RO #:</label>
        <input type="text" v-model="repair_order" class="form-control" placeholder="Enter Repair Order"
          :disabled="disableClaimHeader || dealerFieldsDisabled || disableAllFields" name="repair_order" id="repair_order" />
        <div class="field-error">{{ repair_order_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Full VIN:</label>
        <v-select v-model="product_sn" id="product_sn" name="product_sn" label="text" :filterable="false"
          :options="vinArr" @search="onSearchAssetWithVin" placeholder="Search Vehicle with Vin"
          :disabled="disableClaimHeader || dealerFieldsDisabled || disableAllFields" class='custom-ci-auto-search close-remove'
          @change="vinChanged($event)">
          <template slot="no-options">
            Search Vehicle with Vin...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <div class="field-error">{{ product_sn_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Odometer:</label>
        <input type="number" v-model="odometer" class="form-control" placeholder="Enter Odometer Reading"
          :disabled="disableClaimHeader || dealerFieldsDisabled || disableAllFields" name="odometer" id="odometer" @keypress="filterNumericValue" />
        <div class="field-error">{{ odometer_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Position Code:</label>
        <input type="text" v-model="position_code" class="form-control" placeholder="Enter Position Code Reading"
          name="position_code" id="position_code" @keypress="filterNumericValue" disabled />
        <div class="field-error">{{ position_code_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label require">Created by:</label>
        <input type="text" v-model="created_by" class="form-control" name="created_by" id="created_by" disabled />
      </div>

      <div class="col form-group">
        <label class="control-label">PWA #:</label>
        <input type="text" v-model="pwa" class="form-control" placeholder="Enter Authorization Number" name="pwa"
          id="pwa" :disabled="disableClaimHeader || disableAllFields || disableAllFields"/>
        <div class="field-error">{{ pwa_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label class="control-label">Support Ticket:</label>
        <input type="text" v-model="support_ticket" class="form-control" placeholder="Enter VEV Support Ticket Number"
          name="support_ticket" id="wsc_support_ticketticket" :disabled="disableClaimHeader || disableAllFields"/>
        <div class="field-error">{{ support_ticket_error_msg }}</div>
      </div>

      <div class="col form-group">
        <label
          :class="claim_type == 'Field Fix' || claim_type == 'Recall' ? 'require control-label' : 'control-label'">Field
          Fix/Recall #:</label>
        <v-select class="close-remove" v-model="field_fix_recall" id="field_fix_recall" name="field_fix_recall"
          placeholder="Select Field Fix Campaign" label="text" :options="campaignArr"
          :disabled="((claim_type == 'Field Fix' || claim_type == 'Recall') ? false : true) || disableAllFields || disableClaimHeader">
          <!-- Case 1: No options at all -->
          <template #no-options>
              {{ campaignMessage }}
          </template>
          <!-- Case 2: Results are empty -->
          <template #no-results>
              {{ campaignMessage }}
          </template>
        </v-select>
        <div class="field-error">{{ field_fix_recall_error_msg }}</div>
      </div>

      <!-- should only be accessed by the admin user -->
      <div class="col form-group">
        <label class="control-label" :class="rmaRequired == true ? 'require' : ''">RMA #:</label>
        <input type="text" v-model="rma" class="form-control" placeholder="Enter RMA #" name="rma" id="rma"
          :disabled="disableClaimHeader || !viewAllfields || disableAllFields" />
        <div class="field-error">{{ rma_number_error_msg }}</div>
      </div>

      <div class="col form-group" v-if="viewAllfields">
        <label class="control-label">Open/Closed:</label>
        <v-select class="close-remove" v-model="open_closed" id="open_closed" name="open_closed"
          placeholder="Select Open/Closed" label="text" :options="openCloseArr" :disabled="disableAllFields || disableClaimHeader">
        </v-select>
      </div>

      <!-- should only be accessed by the admin user -->
      <div class="col form-group">
        <label class="control-label">Credit Memo #:</label>
        <input type="text" v-model="credit_memo_number" class="form-control" placeholder="Enter Credit Memo #"
          name="credit_memo_number" id="credit_memo_number" :disabled="true" />
        <div class="field-error">{{ credit_memo_number_error_msg }}</div>
      </div>

      <!-- should only be accessed by the admin user -->
      <div class="col form-group">
        <label class="control-label">Credit Memo Date:</label>
        <div class="input-group">
          <date-picker placeholder="MM/DD/YYYY" id="credit_memo_date" name="credit_memo_date" v-model="credit_memo_date"
            :config="optionsDate" :disabled="true"></date-picker>
          <label for="credit_memo_date" class="fp-calendar input-calender-icon"></label>
        </div>
        <div class="field-error">{{ credit_memo_date_error_msg }}</div>
      </div>

    </div>
    <!-- Comments -->
    <div class="order-summary mt-4">
      <div class="row">
        <div class="col-md-12 pl-0">
          <div class="bg-white radius-5 pl-3 pr-3 pt-3">
            <warranty-claim-comment ref="claimComment"
              @send-comment-data-claim-tab="handleCommentData"
              :openClosedValue="open_closed"></warranty-claim-comment>
          </div>
        </div>
      </div>
    </div>
    <!-- Comments Ends -->

  </div>
</template>
<script>
import Vue from "vue";
import { contractMixins } from '../../mixins/contractMixins';
import { commonMixins } from '../../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
import WarrantyClaimComments from "./WarrantyClaimComments.vue";

Vue.component("loading-content", LoadingContent);
Vue.component("warranty-claim-comment", WarrantyClaimComments);

export default {
  name: "EvClaimTab",
  mixins: [commonMixins, contractMixins],
  props: {
    viewAllfields: {
      type: Boolean,
      default: false
    },
    dealerFieldsDisabled: {
      type: Boolean,
      default: true
    },
    disableAllFields: {
      type: Boolean,
      default: false
    },
    disableClaimHeader: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    location_id: null,
    locationArr: [],
    claim_number: '',
    disableAll: false,
    requestTypeArr: ['Payment', 'Pre-approval'],
    request_type: '',
    claimTypeArr: ['Warranty', 'Field Fix', 'Recall', 'PDI', 'NVI', 'Goodwill/Policy', 'OTC Parts'],
    claimStatusArr: [
      'Accepted',
      'Chargeback',
      'CM Issued',
      'Corrections Made/Dealer Response',
      'Deleted',
      'Draft',
      'In Process',
      'In Review',
      'Modified',
      'Open',
      'Payment Pending',
      'Rejection/Denied',
      'Returned for Corrections',
      'Waiting on Parts'
    ],
    openCloseArr: [
      'Open',
      'Closed'
    ],
    basedOnArr: ["Pre-approval", "Previous Claim", "Template"],
    based_on: "",
    vehicle_id: null,
    vehicleArr: [],
    product_sn: null,
    vinArr: [],
    product_type: "",
    service_bulletin: "",
    wty_agreement: false,
    odometer: "",
    repair_order: "",
    claim_date: "",
    created_by: "",
    wsc_ticket_no: "",
    currency: "",
    comment: "",
    authorization_number: "",
    supplier_authorization_number: "",
    supplier_additional_info: "",
    claimTotalTable: [],
    claim_type: "",
    paid_credit_memo_date: "",
    paid_credit_memo_no: "",
    dealer_location_err_msg: "",
    dealer_group_err_msg: "",
    dealer_code_err_msg: "",
    claim_status_error_msg: "",
    field_fix_recall_error_msg: "",
    claim_number_error_msg: '',
    request_type_error_msg: "",
    claim_type_error_msg: "",
    based_on_error_msg: "",
    product_sn_error_msg: "",
    vehicle_error_msg: "",
    service_bulleting_error_msg: "",
    odometer_error_msg: "",
    repair_order_error_msg: "",
    authorization_number_error_msg: "",
    supplier_authorization_number_error_msg: "",
    supplier_additional_info_error_msg: "",
    claim_date_error_msg: "",
    wsc_ticket_no_error_msg: "",
    optionsDate: {
      format: 'MM/DD/YYYY',
      useCurrent: false,
      widgetPositioning: {
        vertical: 'bottom'
      }
    },
    repairOptionsDate: {
      format: 'MM/DD/YYYY',
      useCurrent: false,
      widgetPositioning: {
        vertical: 'bottom'
      }
    },
    repairCompletionOptionsDate: {
      format: 'MM/DD/YYYY',
      useCurrent: false,
      widgetPositioning: {
        vertical: 'bottom'
      },
      minDate: '12/12/1999' // just a placeholder
    },
    field_fix_recall: "",
    show_campaign_number: false,
    require_pwa_auth: false,
    commentArr: [],
    total_claimed_parts_amount: 0,
    total_claimed_handling_amount: 0,
    total_claimed_labor_amount: 0,
    total_processed_parts_amount: 0,
    total_processed_handling_amount: 0,
    total_processed_labor_amount: 0,
    total_claimed_paid_amount: 0,
    total_processed_paid_amount: 0,
    total_net_paid_amount: 0,
    APIResponse: false,
    dealer_id: '',
    dealerArr: [],
    modifiedDealerArr: [],
    loadAllDealers: false,
    section_verified: false,
    dealer_group: '',
    dealer_code: '',
    claim_status: '',
    last_modification_date: '',
    repair_start_date: '',
    repair_completion_date: '',
    position_code: '',
    rma: '',
    open_closed: 'Open',
    credit_memo_number: '',
    credit_memo_date: '',
    last_modification_date_error_msg: '',
    repair_start_date_error_msg: '',
    repair_completion_date_error_msg: '',
    position_code_error_msg: '',
    credit_memo_date_error_msg: '',
    pwa: '',
    pwa_error_msg: '',
    support_ticket: '',
    support_ticket_error_msg: '',
    claimHeaderId: '',
    isEdit: false,
    disableCompletionDate: true,
    rmaRequired: false,
    rma_number_error_msg: '',
    credit_memo_number_error_msg: '',
    cmIssued: false,
    claimId: "",
    initialClaimData: '',
    currentClaimData: '',
    campaignArr : []
  }),
  watch: {
    repair_start_date: function (repair_date) {
      if (repair_date != '' && repair_date != null) {
        this.disableCompletionDate = false;
        this.repairCompletionOptionsDate.minDate = repair_date;
        if (this.repair_completion_date < this.repair_start_date) {
          this.repair_completion_date = "";
        }
      } else {
        this.repair_completion_date = '';
        this.disableCompletionDate = true;
        this.repairCompletionOptionsDate.minDate = '12/12/1998'; // placeholder
      }
      if (this.dealerFieldsDisabled) {
        this.disableCompletionDate = this.dealerFieldsDisabled;
      }
      this.$emit("send-repair-date", repair_date);
    },
    dealerArr: function (arr) {
      if (arr.length > 0) {
        var self = this;
        self.loading = true;

        self.modifiedDealerArr = arr.map(element => ({
          text: element.name,
          value: element.value,
          parentCode: element.parent_code,
          customerCode: element.code,
          laborRate: element.labor_rate,
          timeTravelRate: element.time_travel_rate,
          distanceTravelRate: element.distance_travel_rate
        }));

        if (!self.$route.params.id && !self.loadAllDealers) {
          self.dealer_id = self.modifiedDealerArr[0];
        }

        self.loading = false;
      }
    },
    dealer_id: function (value) {
      if (value) {
        var self = this;
        self.dealer_group = value.parentCode;
        self.dealer_code = value.customerCode;

        const rates = {
          laborRate: value.laborRate,
          timeTravelRate: value.timeTravelRate,
          distanceTravelRate: value.distanceTravelRate
        };
        this.$emit("send-labor-travel-rate-to-parent", rates);
      }
    },
    product_sn: function (product_sn) {
      var self = this;
      self.vehicle_id = self.product_sn;
      this.emitVINToParent();
      this.getVehicleCampaigns();
    },
    claimTypeArr: function (claimTypeArr) {
      var self = this;
      if (claimTypeArr.length > 0 && !self.isEdit) {
        for (let i = 0; i < claimTypeArr.length; i++) {
          if (claimTypeArr[i].code == 'warranty') {
            self.claim_type = claimTypeArr[i];
            break;
          }
        }
      }
    },
    claim_type: function (claim_type) {
      var self = this;
      if (claim_type.code == "field_fix_recall") {
        self.show_campaign_number = true;
      } else {
        self.show_campaign_number = false;
      }
      if (claim_type.code == "goodwill_policy") {
        self.require_pwa_auth = true;
      } else {
        self.require_pwa_auth = false;
      }

      this.getVehicleCampaigns();
    },
    vinArr(value) {
      if (this.isEdit) {
        this.product_sn = value[0];
        this.populateInitialClaimData(true);
        this.$root.$emit('WarrantyClaimLoadingStatusChanged', false);
      }
    },
    claim_status: function (status) {
      this.$emit("send-claim-status-to-parent", status);
    }
  },
  computed: {
      campaignMessage() {
          if (!this.product_sn) {
              return "Please select VIN to get campaigns";
          }

          if (this.product_sn && this.campaignArr.length === 0) {
              return "No campaigns found for selected VIN";
          }

          return "No matching options";
      }
  },
  mounted() {
    var self = this;
    // self.loadFieldData(['location', 'ev_claim_types']);
    self.loadFieldData(['location']);
    self.populateClaimTotalTable();
    var path = window.location.pathname;
    var segments = path.split("/");
    if (!segments[3]) {
      // self.getClaimNumber();
      var userObj = JSON.parse(localStorage.getItem("user_obj"));
      self.created_by = userObj.username;
      if (!self.viewAllfields) {
        self.claim_status = "Draft";
      }
    } else {
      self.isEdit = true;
    }

  },
  methods: {
    getVehicleCampaigns() {
        const self = this;
        // Extract VIN value safely (works whether product_sn is an object or string)
        var vin = '';
        if (self.product_sn) {
            vin = self.product_sn.value ? self.product_sn.value : '';
        }
        if (!self.isEdit) {
            // Only load campaigns if Field Fix / Recall & VIN is available
            if ((self.claim_type === 'Field Fix' || self.claim_type === 'Recall') && vin) {
                self.loadFieldData(['claim_campaigns'], '', vin);
                return;
            }
            self.campaignArr = [];
            self.field_fix_recall = '';
            return;
        }
        if (
            self.claim_status === 'Draft' &&
            (self.claim_type === 'Field Fix' || self.claim_type === 'Recall')
        ) {
            if (vin !== '') {
                self.loadFieldData(['claim_campaigns'], '', vin);
            }
        }
    },
    vinChanged(newValue){
      if(newValue == null || newValue == ''){
        this.product_sn = '';
      }
    },
    claimTypeChanged(newValue) {
      if (newValue == null || newValue == '') {
        this.claim_type = '';
      }
      if (newValue != "Field Fix" && newValue != "Recall") {
        this.field_fix_recall = "";
      }
    },
    claimStatusChanged(newValue) {
      if (newValue == null || newValue == '') {
        this.claim_status = '';
      }
    },
    gotoNext: function (flag) {
      var self = this;
      var success = self.validateClaimFields();
      // if (success) {
      self.emitDataToParent();
      self.gotoNextStepMixins(flag);
      // }
    },
    onSearchAsset(search, loading) {
      var self = this;
      if (search.length > 3) {
        loading(true);
        self.searchField(loading, search, 'vehicle', '');
      }
    },
    onSearchAssetWithVin(search, loading) {
      var self = this;
      if (search.length > 3) {
        if (typeof loading === 'function') {
          loading(true); // Call the loading function if it's a function
        } else {
          self.loading = true;
        }
        self.searchField(loading, search, 'vehicle_vin_warranty', '');
      }
    },
    populateClaimTotalTable() {
      var self = this;
      self.claimTotalTable = [];
      self.claimTotalTable.push(
        {
          heading: "Parts Amount",
          claimed_amount: "$ " + self.amountFormat(self.total_claimed_parts_amount),
          processed_amount: "$ " + self.amountFormat(self.total_processed_parts_amount),
        },
        {
          heading: "Handling",
          claimed_amount: "$ " + self.amountFormat(self.total_claimed_handling_amount),
          processed_amount: "$ " + self.amountFormat(self.total_processed_handling_amount),
        },
        {
          heading: self.labor_spelling + " Amount",
          claimed_amount: "$ " + self.amountFormat(self.total_claimed_labor_amount),
          processed_amount: "$ " + self.amountFormat(self.total_processed_labor_amount),
        },
        {
          heading: "Other Charges",
          claimed_amount: "$ " + self.amountFormat(0.00),
          processed_amount: "$" + self.amountFormat(0.00),
        },
        {
          heading: "Total Paid",
          claimed_amount: "$ " + self.amountFormat(self.total_claimed_paid_amount),
          processed_amount: "$" + self.amountFormat(self.total_processed_paid_amount),
        },
        {
          heading: "Net Paid",
          claimed_amount: "",
          processed_amount: "$" + self.amountFormat(self.total_net_paid_amount),
        },
      )
    },
    validateClaimFields(rmaRequired, cmIssued) {
      var self = this;
      var success = true;
      self.clearClaimErrorMessages();
      self.rmaRequired = rmaRequired;
      self.cmIssued = cmIssued;

      if (self.dealer_id == null || self.dealer_id == "") {
        self.dealer_location_err_msg = 'Dealer Location Required';
        success = false;
      }
      if (self.dealer_group == null || self.dealer_group == '') {
        self.dealer_group_err_msg = 'Dealer Group Required';
        success = false;
      }
      if (self.dealer_code == null || self.dealer_code == '') {
        self.dealer_code_err_msg = 'Dealer Code Required';
        success = false;
      }
      if (self.isEdit) {
        if (self.claim_number == null || self.claim_number == '') {
          self.claim_number_error_msg = 'Claim Number Required';
          success = false;
        }
      }

      if (self.claim_type == null || self.claim_type == '') {
        self.claim_type_error_msg = 'Claim Type Required';
        success = false;
      }
      if (self.claim_type == 'Field Fix' || self.claim_type == 'Recall') {
        if (self.field_fix_recall == null || self.field_fix_recall == '') {
          self.field_fix_recall_error_msg = 'Please select a campaign';
          success = false;
        }
      }
      if (self.claim_status == null || self.claim_status == '') {
        self.claim_status_error_msg = 'Claim Status Required';
        success = false;
      }
      if (self.repair_start_date == null || self.repair_start_date == '') {
        self.repair_start_date_error_msg = 'Repair Start Date Required';
        success = false;
      }
      if (self.repair_completion_date == null || self.repair_completion_date == '') {
        self.repair_completion_date_error_msg = 'Repair Completion Date Required';
        success = false;
      }
      if (self.repair_order == null || self.repair_order == '') {
        self.repair_order_error_msg = 'Dealer RO Number Required';
        success = false;
      }
      if (self.product_sn == null || self.product_sn == '') {
        self.product_sn_error_msg = 'VIN Required';
        success = false;
      }
      if (self.odometer == null || self.odometer == '') {
        self.odometer_error_msg = 'Odometer Required';
        success = false;
      }
      if (self.position_code == null || self.position_code == '') {
        self.position_code_error_msg = 'Position Code Required';
        success = false;
      }


      if (self.viewAllfields) {
        if (self.cmIssued) {
          if (self.credit_memo_number == null || self.credit_memo_number == '') {
            self.credit_memo_number_error_msg = 'Credit Memo Number Required';
            success = false;
          }
          if (self.credit_memo_date == null || self.credit_memo_date == '') {
            self.credit_memo_date_error_msg = 'Credit Memo Date Required';
            success = false;
          }
        }
        if (self.rmaRequired) {
          if (self.rma == null || self.rma == '') {
            self.rma_number_error_msg = 'RMA Number Required';
            success = false;
          }
        }
      }

      return success;
    },
    clearClaimErrorMessages() {
      var self = this;
      self.dealer_location_err_msg = '';
      self.dealer_group_err_msg = '';
      self.dealer_code_err_msg = '';
      self.claim_number_error_msg = '';
      self.claim_type_error_msg = '';
      self.claim_status_error_msg = '';
      self.last_modification_date_error_msg = '';
      self.claim_date_error_msg = '';
      self.repair_start_date_error_msg = '';
      self.repair_completion_date_error_msg = '';
      self.repair_order_error_msg = '';
      self.product_sn_error_msg = '';
      self.odometer_error_msg = '';
      self.position_code_error_msg = '';
      self.pwa_error_msg = '';
      self.support_ticket_error_msg = '';
      self.field_fix_recall_error_msg = '';
      self.credit_memo_date_error_msg = '';
      self.comment_error_msg = '';
      self.rma_number_error_msg = '';
      self.credit_memo_number_error_msg = '';
    },
    emitDataToParent() {
      var self = this;
      if (self.commentArr.length == 0) {
        var commentArray = "";
      } else {
        var commentArray = self.commentArr;
      }
      const dataToSend = {
        dealer_group: self.dealer_group,
        dealer_location: self.dealer_id,
        dealer_code: self.dealer_code,
        claim_number: self.claim_number,
        claim_type: self.claim_type,
        claim_status: self.claim_status,
        last_modification_date: self.last_modification_date,
        claim_date: self.claim_date,
        repair_start_date: self.repair_start_date,
        repair_completion_date: self.repair_completion_date,
        dealer_ro: self.repair_order,
        vin: self.vehicle_id,
        odometer: self.odometer,
        position_code: self.position_code,
        created_by: self.created_by,
        pwa: self.pwa,
        support_ticket: self.support_ticket,
        field_fix_recall: self.field_fix_recall,
        rma: self.rma,
        open_closed: self.open_closed,
        credit_memo_number: self.credit_memo_number,
        credit_memo_date: self.credit_memo_date,
        verified: self.section_verified,
        claimHeaderId: self.claimHeaderId

      };
      self.$emit("send-claim-data-to-parent", dataToSend);
    },
    emitRmaToParent() {
      const dataToSend = {
        rma: this.rma
      }
      this.$emit("send-rma-to-parent", dataToSend);
    },
    emitCMIssuesToParent() {
      const dataToSend = {
        credit_memo_number: this.credit_memo_number,
        credit_memo_date: this.credit_memo_date,
      }
      this.$emit("send-cm-issued-to-parent", dataToSend);
    },
    getClaimData(claimData) {
      var self = this;
      if (claimData.dealer_id_value > 0) {
        self.dealer_id = { value: claimData.dealer_id_value, text: claimData.dealer_id_text };
      }

      self.authorization_number = claimData.authorization_number;
      self.based_on = claimData.based_on;
      self.claim_date = claimData.claim_date;
      self.claim_number = claimData.claim_number;
      self.comment = claimData.comment;
      self.currency = claimData.currency;
      self.product_sn = claimData.product_sn;
      self.odometer = claimData.odometer;
      self.repair_order = claimData.repair_order;
      self.service_bulletin = claimData.service_bulletin;
      self.wsc_ticket_no = claimData.wsc_ticket_no;
      if (wty_agreement.wty_agreement_customer_repair == "yes") {
        self.wty_agreement = true;
      } else {
        self.wty_agreement = false;
      }
      self.claim_type = { "value": claimData.claim_type, "text": claimData.claim_type_text };
      self.field_fix_recall = claimData.fix_campaign_number;
      self.total_claimed_parts_amount = claimData.part_total_claim_amount;
      self.total_claimed_handling_amount = claimData.part_handling_total_amount;
      self.total_claimed_labor_amount = claimData.labor_total_amount;
      self.total_processed_parts_amount = claimData.part_total_processed_amount;
      self.total_processed_handling_amount = claimData.part_handling_total_processed_amount;
      self.total_processed_labor_amount = claimData.labor_processed_amount;
      self.total_claimed_paid_amount = claimData.total_claimed_paid_amount;
      self.total_processed_paid_amount = claimData.total_processed_paid_amount;
      self.total_net_paid_amount = claimData.total_net_paid_amount;
      self.populateClaimTotalTable();
    },
    getClaimNumber() {
      var self = this;

      self.$parent.loading = true;
      if (self.claim_number != null) {
        $.ajax({
          url: process.env.ROOT_API + "/claim-number",
          type: "GET",
          headers: {
            'Accept': 'application/json',
            "Access-Control-Allow-Origin": '*',
            "Authorization": "Bearer " + localStorage.getItem("tkn"),
            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
            "Cache-Control": "no-cache"
          },
          crossDomain: true,
          dataType: "json",
          success: function (data) {
            self.$parent.loading = false;
            self.claim_number = data.content;
            self.emitClaimNumbertoParent();
          },
          error: function (jqXHR, exception) {
            self.$parent.loading = false;
            self.Registerbtn = "Register";
            self.generateStatusCodeMessage(jqXHR, true, 'asset-group-warranties-search')
          }
        });
      }
    },

    handleCommentData(commentData) {
      var self = this;
      self.commentArr = commentData;
      if(self.isEdit){
        self.saveClaimComment();
      }
    },

    saveClaimComment() {
      var self = this;

      self.$parent.loading = true;

      $.ajax({
        url: process.env.ROOT_API + "/warranty-claim/save-comment",
        type: 'POST',
        data: {
          claimId: self.claimId,
          claimHeaderId: self.claimHeaderId,
          comments: self.commentArr,
          flag: self.claim_status,
        },
        headers: self.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.$parent.loading = false;
        },
        error: function (jqXHR, exception) {
          self.$parent.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'warranty-claim-create')
        }
      });
    },

    onSearchDealer(search, loading) {
      var self = this;
      if (search.length > 2) {
        loading(true);
        self.searchField(loading, search, 'dealer', '');
      }
    },

    getDealerLoadData(loadAllDealers) {
      this.loadAllDealers = loadAllDealers;
      if (!this.loadAllDealers) {
        let userObj = JSON.parse(localStorage.getItem("user_obj"));
        this.loadUserDealerMapper(userObj.id);
      }
    },
    getPositionCodeFromParent(positionCode) {
      this.position_code = positionCode;
    },
    emitClaimNumbertoParent() {
      const dataToSend = {
        claimNumber: this.claim_number
      }
      this.$emit("send-claim-number-to-parent", dataToSend);
    },
    emitVINToParent() {
      const dataToSend = {
        vin: this.vehicle_id.vin,
        wsd: this.vehicle_id.warranty_start_date
      }
      this.$emit("send-vin-to-parent", dataToSend);
    },
    getDataFromParent(claimHeaderData, claimStatus, claimNumber, createdBy,claimId) {
      this.$root.$emit('WarrantyClaimLoadingStatusChanged', true);
      this.claimId = claimId
      this.claim_status = claimStatus;
      this.claim_number = claimNumber;
      this.created_by = createdBy.username;
      this.claim_date = claimHeaderData.claim_date;
      this.claim_type = claimHeaderData.claim_type;
      this.credit_memo_date = claimHeaderData.credit_memo_date;
      this.credit_memo_number = claimHeaderData.credit_memo_number;
      this.dealer_id = {
        text: claimHeaderData.dealer.name,
        value: claimHeaderData.dealer.id,
        customerCode: claimHeaderData.dealer.code,
        parentCode: claimHeaderData.dealer.parent.code,
        laborRate: claimHeaderData.dealer.labor_rate || 0,
        timeTravelRate: claimHeaderData.dealer.time_travel_rate || 0,
        distanceTravelRate: claimHeaderData.dealer.distance_travel_rate || 0
      };
      this.repair_order = claimHeaderData.dealer_ro_number;
      this.field_fix_recall = claimHeaderData.field_fix_recall;
      this.claimHeaderId = claimHeaderData.id;
      this.last_modification_date = claimHeaderData.last_modification_date;
      this.odometer = claimHeaderData.odometer;
      this.open_closed = claimHeaderData.open_closed;
      this.position_code = claimHeaderData.position_code;
      this.pwa = claimHeaderData.pwa_number;
      this.repair_completion_date = claimHeaderData.repair_completion_date;
      this.repair_start_date = claimHeaderData.repair_start_date;
      this.rma = claimHeaderData.rma_number;
      this.support_ticket = claimHeaderData.support_ticket;
      this.vehicle_id = claimHeaderData.vehicle;
      this.section_verified = (claimHeaderData.verified == 0) ? false : true;
      if(this.vehicle_id != null){
        this.onSearchAssetWithVin(claimHeaderData.vehicle.vin, "loading");
      } else {
        this.$root.$emit('WarrantyClaimLoadingStatusChanged', false);
      }
      this.populateCommentData(claimHeaderData.ev_claim_comments);
      this.emitClaimNumbertoParent();
      this.$nextTick(() => {
        this.populateInitialClaimData(true);
      });
    },
    populateInitialClaimData(flag) {
      if(flag) {
        setTimeout(() => {
          this.setInitialValue(flag);
        }, 500);
      } else {
        return this.setInitialValue(flag);
      }
    },
    setInitialValue(flag){
      const claimData = JSON.stringify({
          dealer_group: this.dealer_group,
          dealer_location: this.dealer_id,
          dealer_code: this.dealer_code,
          claim_number: this.claim_number,
          claim_type: this.claim_type,
          claim_status: this.claim_status,
          last_modification_date: this.last_modification_date,
          claim_date: this.claim_date,
          repair_start_date: this.repair_start_date,
          repair_completion_date: this.repair_completion_date,
          dealer_ro: this.repair_order,
          vin: this.vehicle_id,
          odometer: this.odometer,
          position_code: this.position_code,
          created_by: this.created_by,
          pwa: this.pwa,
          support_ticket: this.support_ticket,
          field_fix_recall: this.field_fix_recall,
          rma: this.rma,
          open_closed: this.open_closed,
          credit_memo_number: this.credit_memo_number,
          credit_memo_date: this.credit_memo_date,
          verified: this.section_verified,
          claimHeaderId: this.claimHeaderId
        });

        if (flag) {
          this.initialClaimData = '';
          this.initialClaimData = claimData;
        } else {
          this.currentClaimData = '';
          this.currentClaimData = claimData;
          
          return this.initialClaimData !== this.currentClaimData;
        }
    },
    populateCommentData(commentData) {
      this.$refs.claimComment.getDataFromParent(commentData);
    },
    clearAllFields() {
      var self = this;
      self.clearClaimErrorMessages();

      if (self.loadAllDealers) {
        self.dealerArr = [];
        self.modifiedDealerArr = [];
      }
      self.section_verified = false;
      self.dealer_id = '';
      self.dealer_group = '';
      self.dealer_code = '';
      self.claim_type = '';
      self.claim_status = 'Draft';
      self.last_modification_date = '';
      self.claim_date = '';
      self.repair_start_date = '';
      self.repair_completion_date = '';
      self.repair_order = '';
      self.product_sn = '';
      self.odometer = '';
      self.position_code = '';
      self.pwa = '';
      self.support_ticket = '';
      self.field_fix_recall = '';
      self.rma = '';
      self.open_closed = '';
      self.credit_memo_number = '';
      self.credit_memo_date = '';

      self.commentArr = [];
      self.$refs.claimComment.clearAllFields();
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvClaimTab.vue